// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"27":"3a0a590d","348":"8f96b4da","571":"1db50410","924":"f9eaf155"}[chunkId] + ".chunk.js";
};